import { useQuery } from "@tanstack/react-query";
import { getUsers } from "../api/auth";

// `enabled` — модал, монтиран и затворен (Маркиране държи модалите си
// монтирани), тегли чак при отваряне, вместо при всяко връщане към масите
export const useUsers = (
  role?: string,
  reports?: boolean,
  without?: string,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: ["users", role ?? "all", reports ?? false, without ?? "none"],
    queryFn: () => getUsers(role, reports, without),
    staleTime: 0, // Данните са stale веднага — при всяко mount се прави нов fetch
    refetchOnMount: "always", // Винаги рефреширай при mount на компонента
    enabled: options?.enabled ?? true,
  });
};
